'use client'

import React from "react";
import { motion } from 'framer-motion';
import { Grid, Typography, Box, Container } from '@mui/material';
import Link from 'next/link';
import { Karte } from '@/components/ui/Karte';

// Der Kartenausschnitt zeigt Rebhaldenweg 52, 7206 Igis.
const KARTE_EINGEBETTET = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d963.0422787276151!2d9.572797429715257!3d46.944104646356365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4784c9d919cef6df%3A0x86e98213c579a6d0!2sRebhaldenweg%2052%2C%207206%20Igis!5e0!3m2!1sen!2sch!4v1707817244642!5m2!1sen!2sch';
const KARTE_LINK = 'https://maps.app.goo.gl/Jvk9r6R4dgVobw1E6';

export const KontaktSection = ({ data }) => {
  // data ist der Datensatz selbst; frueher kam hier ein Array mit einem Element an.
  const contact = data;
  return (
    <motion.section
      className="section-large"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
    >
      <div className="section-header">
        <div className="section-title">
          <Typography variant="h3" component="h1" gutterBottom>
            Kontakt
          </Typography>
        </div>
      </div>
      <div className="section-body">
        <Container maxWidth="full" className="no-padding">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box sx={{ mb: 2 }}>
                {contact &&
                  <Box sx={{ mb: 2 }}>
                    <Link href="https://maps.app.goo.gl/Jvk9r6R4dgVobw1E6" target="_blank" rel="noopener noreferrer" underline="hover">
                      <Typography className="text-inherit">{contact.titel}</Typography>
                      <Typography className="text-inherit">{contact.strasse_und_nummer}</Typography>
                      <Typography className="text-inherit">{contact.wohnort}</Typography>
                    </Link>
                    <Typography>
                      <Link href={`tel:${contact.telefon}`} underline="hover">{contact.telefon}</Link>
                    </Typography>
                    <Typography>
                      <Link href={`tel:${contact.mobile}`} underline="hover">{contact.mobile}</Link>
                    </Typography>
                    <Typography>
                      <Link href={`mailto:${contact.email}`} underline="hover">{contact.email}</Link>
                    </Typography>
                  </Box>}
                <Karte eingebettetUrl={KARTE_EINGEBETTET} kartenUrl={KARTE_LINK} />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </div>
    </motion.section>
  );
};
